module.exports = __webpack_public_path__ + "static/media/email_unselected.570e7537.svg";